import { useMutation } from '@tanstack/react-query';
import API from 'lib/api';

interface IUserData {
  partnerToken: string;
  partnerCommunitySysId: string;
  sessionId: string;
  userEmail: string;
  jsonUserData: {
    lotInfo: {
      assetUrl: string;
      planName: string;
      planCode: string;
      elevationName: string;
      phase: string;
      orientation: string;
      sqft: number;
      price: number;
      address: string;
      description: string;
      description2: string;
      description3: string;
    };
  };
  app: string;
}

export const useUserDataMutation = () => {
  return useMutation((body: IUserData) => API.post(`/userdata`, body), {
    onSuccess: (siteMapResult, { partnerToken }) => {
      window.parent.postMessage({ partnerToken, siteMapResult }, '*');
    },
  });
};
